import React, {Fragment, useState, useContext, useEffect } from "react";
import DataTable from "react-data-table-component";
import ActionOptions from "../../Common/Component/ActionOptions";
import { DropdownItem } from "reactstrap";
import { CommonModal, Spinner } from "../../../AbstractElements";
import CustomizerContext from "../../../_helper/Customizer";
import { CarTypeColumns } from "../../../Data/CarType/CarType";
import { deleteRecoverCarType } from "../../../Services/Car.service";
import { showAlert } from "../../../Services/Shared.service";
import { DriverSchemeDeductionsColumns } from "../../../Data/Driver/DriverType";
import {  deletSchemeDeductions, getAllDriverSchemeDeduction } from "../../../Services/Driver.service";
import SharedDataContext from "../../../_helper/SharedData";
// import { DriverSchemeDeductionForm } from "../Forms/DriverSchemeDeductionForm";
// import DriverSchemeEdit from "../EditForms/DriverSchemeEdit";
import DriverShcemeDeductionEdit from "../EditForms/DriverShcemeDeductionEdit";


function DriverSchemeConfigTable({
  isRefresh,
  setShowApiLoader,
  fetchTableData,
  paginationPerPage,
  paginationTotalRows,
  onChangePage,
  onChangeRowsPerPage,
  onEditClick,
  loader,
  editId,
  setEditId,
  triggerRefresh,
  driverSchemeTable
}) {

  const {cityData}  = useContext(SharedDataContext)
  const { mix_background_layout} = useContext(CustomizerContext);
  const [driverSchemeDeductionObj, setDriverSchemeDeductionObj] = useState();
  const [isModal,setIsModal] = useState(false)
  const [schemeDeductionId,setSchemeDeductionId] = useState();
  // const [driverSchemeTable,setDriverSchemeTable] = useState([])

  const closeModal=()=>{
    setIsModal(!isModal);
    // triggerRefresh()
  }
  
const conditionalRowStyles = [

    {
      when: row => row["Deleted"] ,
      style: row => ({ backgroundColor: row["Deleted"] ? "#F9B5A6" : ""}),
    },
];


const isDeleteUpdate =(schemeDeductionId,isDeleted)=>{
  const obj = {
    schemeDeductionId:schemeDeductionId,
    isDeleted:isDeleted
  }
  deletSchemeDeductions(obj).then((resp)=>{
    showAlert("success","Driver Scheme Dedution Deleted")
    triggerRefresh()
  }).catch((err)=>{
   showAlert("error", err.response?.data?.message ? err.response.data.message : "Something went wrong")
  })
}

const editDriverConfig =(editId)=> {
  console.log("Edit id",editId)
  setSchemeDeductionId(editId)
  setIsModal(true)
}


const processData = driverSchemeTable.map((element, index) => {
  return {
      
    driver_type: element.driverSchemeName? element.driverSchemeName : "-",
    deduction_type: element.driverDeductionName ? element.driverDeductionName : "-",
    deduction_value: element.value ? element.value : "-",
    service_city: element.serviceCityName ? element.serviceCityName:"-",
    is_subscription: element.isSubscription ? "True":"False",
    calculation_type: element.calculateType ? element.calculateType:"-",
    booking_type: element.bookingTypeDeduction ? element.bookingTypeDeduction:"-",
    // minimum_balance: element.bookingTypeDeduction ? element.bookingTypeDeduction:"-",
    // applicable_from: element.applicableFrom ? element.applicableFrom:"-",
    // applicable_to: element.applicableTo ? element.applicableTo:"-",
    value_type: element.valueType ? element.valueType:"-",
    value:element.value?element.value:"-",
    // IsDeleted:element.isDeleted? "True":"False",
    Deleted: element.isDeleted,
    action: (
          <ActionOptions key={index}>
              <Fragment>
                  <DropdownItem
                      className="border-0"
                      key={"row-edit"}
                      disabled={element.driverTypeDelete?element.driverTypeDelete:false}
                      onClick={() => {
                         isDeleteUpdate(element.id,element.isDeleted?false:true)
                      }}
                  >
                      <i className="fa fa-trash-o"></i> {element.isDeleted ? "Recover" : "Delete"}
                  </DropdownItem>
                  <DropdownItem
                      className="border-0"
                      onClick={() => {
                        editDriverConfig(element.id)
                      }}
                  >
                      <i class="fa fa-pencil" ></i>{""}{"Edit"}
                  </DropdownItem>
              </Fragment>
          </ActionOptions>
    ),
  };
});

return (
  <div>
    <div className="table-responsive ">
      <DataTable
        columns={DriverSchemeDeductionsColumns}
        data={processData}
        // center={true}
        fixedHeader
        fixedHeaderScrollHeight={"57vh"}
        pagination
        paginationPerPage={paginationPerPage}
        paginationTotalRows={paginationTotalRows}
        onChangePage={onChangePage}
        onChangeRowsPerPage={onChangeRowsPerPage}
        // customStyles={customStyles}
        conditionalRowStyles={conditionalRowStyles}
        paginationServer
        progressPending={loader}
        progressComponent={<div className="loader-box" style={{ height: "57vh" }}>
        <Spinner attrSpinner={{ className: "loader-3", style: { width: "30px", height: "30px", borderColor: "#39B54A", borderBottomColor: "transparent" } }} />
    </div>}
        theme={mix_background_layout == "dark-only" ? "dark" : "default"}
      />
    </div>
    <DriverShcemeDeductionEdit closeModal={closeModal} editId={schemeDeductionId} isModal={isModal} triggerRefresh={triggerRefresh}/>
  </div>
);
}

export default DriverSchemeConfigTable;
